import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { lazy, Suspense } from "react";
import { Redirect, Route } from "react-router-dom";
import Loader from "../components/loader";
import PrivateRoute from "./PrivateRoute";

const AdjuntarDocumentacion = lazy(
    () => import("../pages/adjuntar-documentacion")
);
const AnhadirCliente = lazy(() => import("../pages/anhadir-cliente"));
const AnhadirEmpresa = lazy(() => import("../pages/anhadir-empresa"));
const AsignacionCamion = lazy(() => import("../pages/asignacion-camion"));
const AsignarCamion = lazy(() => import("../pages/asignar-camion"));
const GestionarPedido = lazy(() => import("../pages/gestionar-pedido"));
const Home = lazy(() => import("../pages/home"));
const IniciarViaje = lazy(() => import("../pages/iniciar-viaje"));
const Login = lazy(() => import("../pages/login"));
const NuevoPedido = lazy(() => import("../pages/nuevo-pedido"));
const ClonarPedido = lazy(() => import("../pages/clonar-pedido"));
const ResumenPedido = lazy(() => import("../pages/resumen-pedido"));
const TerminarViaje = lazy(() => import("../pages/terminar-viaje"));
const VerificacionControl = lazy(() => import("../pages/verificacion-control"));
const ViajeIniciado = lazy(() => import("../pages/viaje-iniciado"));
const ViajeTerminado = lazy(() => import("../pages/viaje-terminado"));
const ViajeValidado = lazy(() => import("../pages/viaje-validado"));
const DocumentacionAdjuntada = lazy(
    () => import("../pages/documentacion-adjuntada")
);
const CompletarPedido = lazy(() => import("../pages/completar-pedido"));
const PrivacyPolicy = lazy(() => import("../pages/privacy-policy"));
const GestionUsuarios = lazy(() => import("../pages/gestion-usuarios"));
const EditarUsuario = lazy(() => import("../pages/gestion-usuarios/editar-usuario"));
const GestionOrganizaciones = lazy(() => import("../pages/gestion-organizaciones"));
const VerOrganizacion = lazy(() => import("../pages/gestion-organizaciones/ver-organizacion"));
const Enganche = lazy(() => import("../pages/enganche"));
const Desenganche = lazy(() => import("../pages/desenganche"));
const GestionEnganche = lazy(() => import("../pages/gestion-enganche"));

const AppRouter = () => (
    <IonReactRouter>
        <Suspense fallback={<Loader />}>
            <IonRouterOutlet>
                <Route exact path="/login">
                    <Login />
                </Route>
                <Route exact path="/privacidad">
                    <PrivacyPolicy />
                </Route>
                <PrivateRoute exact path="/home" component={Home} />
                <PrivateRoute
                    exact
                    path="/nuevo-pedido/:orderNumber?"
                    component={NuevoPedido}
                />
                <PrivateRoute
                    exact
                    path="/clonar-pedido/:orderNumber?"
                    component={ClonarPedido}
                />
                <PrivateRoute
                    exact
                    path="/gestionar-pedido"
                    component={GestionarPedido}
                />
                <PrivateRoute
                    exact
                    path="/resumen-pedido/:orderNumber"
                    component={ResumenPedido}
                />
                <PrivateRoute
                    exact
                    path="/verificacion-control/:orderNumber"
                    component={VerificacionControl}
                />
                <PrivateRoute
                    exact
                    path="/viaje-validado"
                    component={ViajeValidado}
                />
                <PrivateRoute
                    exact
                    path="/anhadir-empresa"
                    component={AnhadirEmpresa}
                />
                <PrivateRoute
                    exact
                    path="/anhadir-cliente"
                    component={AnhadirCliente}
                />
                <PrivateRoute
                    exact
                    path="/iniciar-viaje/:orderNumber"
                    component={IniciarViaje}
                />
                <PrivateRoute
                    exact
                    path="/viaje-iniciado/:orderNumber"
                    component={ViajeIniciado}
                />
                <PrivateRoute
                    exact
                    path="/terminar-viaje/:orderNumber"
                    component={TerminarViaje}
                />
                <PrivateRoute
                    exact
                    path="/viaje-terminado/:orderNumber"
                    component={ViajeTerminado}
                />
                <PrivateRoute
                    exact
                    path="/asignar-camion/:orderNumber"
                    component={AsignarCamion}
                />
                <PrivateRoute
                    exact
                    path="/asignacion-camion/:matricula"
                    component={AsignacionCamion}
                />
                <PrivateRoute
                    exact
                    path="/adjuntar-documentacion/:orderNumber"
                    component={AdjuntarDocumentacion}
                />
                <PrivateRoute
                    exact
                    path="/documentacion-adjunta/:orderNumber"
                    component={DocumentacionAdjuntada}
                />
                <PrivateRoute
                    exact
                    path="/completar-pedido/:orderNumber"
                    component={CompletarPedido}
                />
                <PrivateRoute
                    exact
                    path="/enganche"
                    component={Enganche}
                />
                <PrivateRoute
                    exact
                    path="/desenganche"
                    component={Desenganche}
                />
                <PrivateRoute
                    exact
                    path="/gestion-enganche"
                    component={GestionEnganche}
                />
                <PrivateRoute
                    exact
                    path="/gestion-usuarios"
                    component={GestionUsuarios}
                />
                <PrivateRoute
                    exact
                    path="/gestion-usuarios/:id"
                    component={EditarUsuario}
                />
                <PrivateRoute
                    exact
                    path="/gestion-organizaciones"
                    component={GestionOrganizaciones}
                />
                <PrivateRoute
                    exact
                    path="/gestion-organizaciones/:id"
                    component={VerOrganizacion}
                />
                <Route exact path="/">
                    <Redirect to="/login" />
                </Route>
            </IonRouterOutlet>
        </Suspense>
    </IonReactRouter>
);

export default AppRouter;
